window.addEventListener('DOMContentLoaded', () => {

    document.querySelector('#custom-announcement-banner .action-close').addEventListener('click', () => {
        document.querySelector('#custom-announcement-banner').style.display = 'none';
        $.cookie('custom-announcement-banner', Date.now(), { expires: 7 });
    });

    if(true || $.cookie('custom-announcement-banner') == undefined){
        document.querySelector('#custom-announcement-banner').style.display = 'block';
        new Swiper('#custom-announcement-banner', {
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            keyboard: {
                enabled: true,
            }
        });
    } else {
        console.log($.cookie('custom-announcement-banner'));

        // compare cookie date with message date
        var messages = $('#custom-announcement-banner .message');
        messages.each(function(index, element){
            if(element.getAttribute('data-day') && element.getAttribute('data-month') && element.getAttribute('data-year')) {
                var day = element.getAttribute('data-day');
                var month = element.getAttribute('data-month');
                var year = element.getAttribute('data-year');
                var messageTimestamp = new Date(year, month - 1, day).getTime();

                var cookieTimestamp = $.cookie('custom-announcement-banner');
                if (messageTimestamp >= cookieTimestamp) {
                    $.removeCookie('custom-announcement-banner');
                    document.querySelector('#custom-announcement-banner').style.display = 'block';
                }
            }
        });
    }
});